import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.module';
import { version } from './app/version';
import * as Sentry from "@sentry/angular";

Sentry.init({
  dsn: "https://ec121baa91cf9c5744308fb5772a89e2@o4510704667721728.ingest.us.sentry.io/4510709327527936",
  release: `pnc-web@${version.v}`,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
